import React from 'react'
import {FileComponent, FileComponentMode, FileComponentProps} from "module/CustomField/component/input/FileComponent";
import {InputType} from 'module/CustomField/util/CFInputType'

export function convertCFInputTypeToFileMode(cfInputType: string): FileComponentMode[] {
	switch (cfInputType) {
		case InputType.File:
			return ['file']
		case InputType.Image:
		case InputType.Photo:
			return ['image']
		case InputType.Document:
			return ['document']
		case InputType.DocumentOrImage:
			return ['document', 'image']
		case InputType.Video:
			return ['video']
		default:
			throw new Error("invalid input type for FileComponent")
	}
}

export function CustomFieldFileComponent(props: FileComponentProps) {
	return <div className={'CustomFieldFileComponent CustomFieldComponentBorder'}>
		<FileComponent {...props}/>
	</div>
}